/*
 * Code promo dans le panier (tiroir + page) pour Manoir de la Chaussure.
 * Applique/retire un code via /cart/update.js et rafraichit les sections Dawn.
 */
(function () {
  if (window.__mdcCartDiscountBound) return;
  window.__mdcCartDiscountBound = true;

  function postUpdate(payload) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json();
    });
  }

  function getSections() {
    var list = [];
    if (document.getElementById('CartDrawer')) {
      list.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '#CartDrawer' });
    }
    var items = document.getElementById('main-cart-items');
    if (items) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    var footer = document.getElementById('main-cart-footer');
    if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    return list;
  }

  function innerFrom(html, selector) {
    if (!html) return null;
    try {
      var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return node ? node.innerHTML : null;
    } catch (e) {
      return null;
    }
  }

  function refresh(sections, rendered) {
    if (!rendered) return;
    sections.forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container) return;
      var target = container.querySelector(s.selector) || container;
      var inner = innerFrom(rendered[s.section], s.selector);
      if (inner != null) target.innerHTML = inner;
    });
    // Le rafraichissement du tiroir remplace l'overlay : on rebranche sa fermeture.
    var drawer = document.querySelector('cart-drawer');
    var overlay = document.getElementById('CartDrawer-Overlay');
    if (drawer && overlay && typeof drawer.close === 'function') {
      overlay.addEventListener('click', function () {
        drawer.close();
      });
    }
  }

  function showError(msg) {
    document.querySelectorAll('[data-cart-discount] [data-discount-error]').forEach(function (el) {
      el.textContent = msg;
      el.hidden = false;
    });
  }

  function setBusy(on) {
    document.querySelectorAll('[data-cart-discount]').forEach(function (w) {
      w.classList.toggle('is-busy', on);
    });
  }

  function submitDiscount(code) {
    setBusy(true);
    var sections = getSections();
    var names = sections.map(function (s) {
      return s.section;
    });
    var url = window.location.pathname;

    postUpdate({ discount: code, sections: names, sections_url: url })
      .then(function (cart) {
        var invalid = false;
        if (code) {
          var entry = (cart.discount_codes || []).find(function (c) {
            return c.code && c.code.toLowerCase() === code.toLowerCase();
          });
          invalid = !entry || entry.applicable === false;
        }
        if (invalid) {
          // On retire le code rejete pour ne pas laisser un etat incoherent.
          return postUpdate({ discount: '', sections: names, sections_url: url }).then(function (clean) {
            refresh(sections, clean.sections);
            setBusy(false);
            showError('Code « ' + code + ' » invalide ou non applicable à ce panier.');
          });
        }
        refresh(sections, cart.sections);
        setBusy(false);
      })
      .catch(function () {
        setBusy(false);
        showError('Une erreur est survenue. Veuillez réessayer.');
      });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var applyBtn = e.target.closest('[data-discount-apply]');
    var removeBtn = e.target.closest('[data-discount-remove]');
    if (!applyBtn && !removeBtn) return;
    e.preventDefault();
    if (applyBtn) {
      var wrap = applyBtn.closest('[data-cart-discount]');
      var input = wrap && wrap.querySelector('[data-discount-input]');
      var code = input && input.value ? input.value.trim() : '';
      if (!code) {
        if (input) input.focus();
        return;
      }
      submitDiscount(code);
    } else {
      submitDiscount('');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.matches && t.matches('[data-discount-input]')) {
      e.preventDefault();
      var wrap = t.closest('[data-cart-discount]');
      var btn = wrap && wrap.querySelector('[data-discount-apply]');
      if (btn) btn.click();
    }
  });
})();
